/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterCaratWeight_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuCaratWeight_itemSearch">;
    readonly " $refType": "SbRespRefineMenuFilterCaratWeight_itemSearch";
};
export type SbRespRefineMenuFilterCaratWeight_itemSearch$data = SbRespRefineMenuFilterCaratWeight_itemSearch;
export type SbRespRefineMenuFilterCaratWeight_itemSearch$key = {
    readonly " $data"?: SbRespRefineMenuFilterCaratWeight_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterCaratWeight_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterCaratWeight_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuCaratWeight_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'e1a176908cb88e74c5bfbd6093c521da';
export default node;
